import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles, redirect = "/" }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) return (
        <div className="h-screen flex items-center justify-center text-muted-foreground text-sm">Loading…</div>
    );
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
    if (roles && !roles.includes(user.role)) {
        // Prospects only ever belong in their own area — avoid redirect loops.
        if (user.role === "Prospect") return <Navigate to="/my-quotes" replace />;
        return <Navigate to={redirect} replace />;
    }
    return children;
}
